import type { PresetV2 } from "./mockData";

// Feature flag del modo "Video con influencer". Mientras esté en `false` el
// modo queda OCULTO para TODOS (incluidos dev testers) — tanto en el design-row
// de la home V2 como en la pantalla de Modos. Poner en `true` para volver a
// mostrarlo solo a dev testers (sigue gateado por `devOnly` + `isDevTester`).
export const VIDEO_INFLUENCER_ENABLED = true;

// Catálogo de "modos" de generación de Interfaz V2 (los mismos que aparecen en
// la home V2 / el design-row). Centralizado acá para reusarlo en la pantalla
// de Modos.
//
// Cada modo incluye el objeto `preset` EXACTO que usa InterfazV2 para abrir el
// sheet del modo (mismo id/kind/imágenes que las cards sintéticas de la home).
// Se pasa como `state.presetData` al navegar para que InterfazV2 monte el sheet
// en el primer paint (mecanismo `initialNavPreset`) y no se vea un flash de la
// home V2.

export interface ModeCard {
  /** Segmento de ruta del modo en V2: `/interfaz-v2/modo/<path>`. */
  path: string;
  /** Carátula en video (mp4 corto, autoplay loop muteado). */
  video: string;
  /** Imagen de fallback mientras carga el video. */
  poster: string;
  /** Preset que abre el modo en V2 (espeja las cards del design-row). */
  preset: PresetV2;
  /** Si true, el modo solo se muestra a dev testers (los consumidores de
   *  `MODES` deben filtrar con `isDevTester`). */
  devOnly?: boolean;
}

// Orden igual al design-row de la home V2: [auto, modelo, catálogo, asistente,
// anuncio].
export const MODES: ModeCard[] = [
  {
    path: "auto",
    video: "/images/modo_automatico/modo_auto_caratula_desktop.mp4",
    poster: "/images/modo_automatico/modo_auto_caratula.png",
    preset: {
      id: "imagen-auto-card",
      title: "Generar imagen automáticamente",
      description:
        "Sumá tu producto y la IA arma todo: fondo, escena y luz por vos.",
      imageUrl: "/images/modo_automatico/modo_auto_caratula.png",
      imageUrlFull: "/images/modo_automatico/modo_auto.png",
      kind: "design-auto",
      creditosPorUnidad: 1,
      unidadConsumo: "imagen",
    },
  },
  {
    path: "modelo",
    video: "/images/modo_con_modelo/modo_modelo_caratula_desktop.mp4",
    poster: "/images/modo_con_modelo/fot_modelo.png",
    preset: {
      id: "imagen-con-modelo",
      title: "Generar imagen personalizada",
      description:
        "Tu producto sobre un modelo IA en la pose y el fondo que vos elijas.",
      imageUrl: "/images/modo_con_modelo/fot_modelo.png",
      imageUrlFull: "/images/modo_con_modelo/modelo_gia.png",
      kind: "design-modelo",
      creditosPorUnidad: 1,
      unidadConsumo: "imagen",
    },
  },
  {
    path: "catalogo",
    video: "/images/modo_catalogo_ia/modo_catalogo_caratula_desktop.mp4",
    poster: "/images/modo_catalogo_ia/modo_catalogo_hero.png",
    preset: {
      id: "catalogo-ia-card",
      title: "Generar catálogo con IA",
      description:
        "photoshoots por producto con varias vistas y poses en un solo proceso.",
      imageUrl: "/images/modo_con_modelo/fot_modelo.png",
      imageUrlFull: "/images/modo_catalogo_ia/modo_catalogo_hero.png",
      kind: "catalogo-ia",
      creditosPorUnidad: 1,
      unidadConsumo: "imagen",
    },
  },
  {
    path: "asistente",
    video: "/images/modo_asistente/modo_asistente_caratula_desktop.mp4",
    poster: "/images/modo_asistente/modo_asistente_caratula_mobile.png",
    preset: {
      id: "asistente-marketing-card",
      title: "Asistente de contenido",
      description: "Generá, analizá y planificá tu contenido",
      imageUrl: "/images/modo_con_modelo/fot_modelo.png",
      imageUrlFull: "/images/modo_catalogo_ia/modo_catalogo_hero.png",
      kind: "asistente",
      creditosPorUnidad: 1,
      unidadConsumo: "imagen",
    },
  },
  {
    path: "anuncio",
    video: "/images/modo_anuncio/modo_anuncio_caratula_desktop.mp4",
    poster: "/images/modo_anuncio/modo_anuncio_hero.png",
    preset: {
      id: "anuncio-card",
      title: "Anuncio",
      description:
        "Texto, colores y formato — armá un anuncio listo para publicar.",
      imageUrl: "/images/modo_con_modelo/fot_modelo.png",
      imageUrlFull: "/images/modo_anuncio/modo_anuncio_hero.png",
      kind: "anuncio",
      creditosPorUnidad: 1,
      unidadConsumo: "imagen",
    },
  },
  {
    // Modo "Video con influencer" — DEV ONLY (scaffold). Carátula en video
    // LANDSCAPE propia (16:9, para el slot 3:2 de la página Modos) + su poster.
    // El hero MOBILE usa otro asset vertical (720x960). La miniatura (portrait)
    // es la imagen "al lado de la explicación". Ver ADR-506 / ADR-509.
    path: "video-influencer",
    devOnly: true,
    video: "/images/modo_video_ugc/modo_video_ugc_caratula_desktop.mp4",
    poster: "/images/modo_video_ugc/modo_video_ugc_caratula_desktop.png",
    preset: {
      id: "video-influencer-card",
      title: "Video con influencer",
      description:
        "Generá un video de tu producto presentado por un influencer IA, con un gancho que enganche en los primeros segundos.",
      imageUrl: "/images/modo_video_ugc/modo_video_ugc_miniatura.png",
      imageUrlFull: "/images/modo_video_ugc/modo_video_ugc_miniatura.png",
      poster: "/images/modo_video_ugc/modo_video_ugc_caratula_desktop.png",
      kind: "video-influencer",
      outputType: "video",
      creditosPorUnidad: 1,
      unidadConsumo: "segundo",
    },
  },
];
